export const WALLET = '/wallet'
export const USER = '/user'
export const SYSTEM = '/system'
export const PROPHET_GAME = '/orderbook-market'
export const MARKET = '/market'
export const USER_MARKET = '/userMarket'
export const CRYPTO_PRICE = '/crypto-price'